import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 16h2a2 2 0 1 0 0 -4h-2v-4h4","key":"svg-0"}],["path",{"d":"M5 16v.01","key":"svg-1"}],["path",{"d":"M15 16l4 -4","key":"svg-2"}],["path",{"d":"M19 16l-4 -4","key":"svg-3"}]]

const IconMultiplier05x = createReactComponent('outline', 'multiplier-0-5x', 'Multiplier05x', __iconNode);

export default IconMultiplier05x;